import React, { useState, ChangeEvent, useEffect } from 'react';
import { Tab, Nav, Row } from 'react-bootstrap';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import { sharePolicyDetails, setInboundPaymentFromResponse, updateLeadDetailsInStore, setIsBrokerSent } from "@src/store/slices/insurance";
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify'; 
import { useNavigate } from 'react-router-dom';
import FullPageLoader from '@common/FullPageLoader';
import Modal from '@common/ModalPopup';
import { APP_TYPE_WITH_UCF, INBOUND_PAYMENT_FROM_CUSTOMER, WITH_UCF_PAYMENT_OPTION, STANDALONE_PAYMENT_OPTION, INBOUND_PAYMENT_FROM_SALES_TEAM, APP_TYPE_STANDALONE, SHARE_METHOD, ROLE_FEATURES, DOCUMENT_CATEGORY, CURRENCY_SYMBOL, PHILIPPINE_CURRENCY, STATUS_SUB_STATUS, ALLOW_LEAD_SOURCE, INS_TYPE_CTPL, DSA_LEAD_SOURCE, MARKETING_LEAD_SOURCE, INSTALLMENT, AGENCY_PAYMENT_OPTION, INBOUND_PAYMENT_FROM_OTO_INSURANCE, AGENCY_STATUS,COUNTRY_CODE, WITHOUT_RULE_ENGINE,APP_TYPE_AGENCY, APP_TYPE_RENEWAL, INS_INSURANCE_ID_STAGE, WHATSAPP_WEB_URL,APP_TYPE_ARTEYO,STATUS_SUCCESS, TEMPLATE_TYPE_BROKER, TEMPLATE_TYPE_POLICY_SHARED, STATUS_FIELD} from "@src/config/constant";
import LeadRemarksButton from '../../common/LeadRemarksButton';
import * as HELPER from "../../../../config/helper";
import ReactSelect from '@common/ReactSelect';
import { getDocumentListing } from '../../../../store/slices/common';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '@src/context/LanguageContext';
import { ACTION_STATUS, COND_SHOW_FIELDS_ACC_INSURERS, EXISTING_POLICY_DOC_ID, POLICY_HOLDER, SENT_TO_VERIFICATION, VEHICLE_CHILD_IDS, VEHICLE_DOC_ID } from '@src/config/id/constant';

const CONFIRMATION_POPUP_VALUE = [
    { value: 'yes', label: "Yes" },
    { value: 'no', label: "No" }
];

const ShareDetailsForm = (props: any) => {
    const [switchValue, setSwitchValue] = useState<string[]>([]);
    const [selectedDocType, setSelectedDocType] = useState<any>([]);
    let [documentCategoryList, setDocumentCategoryList] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [showFirstSubmitDocs, setShowFirstSubmitDocs] = useState<any>([]);
    const [showDisbursalDocs, setShowDisbursalDocs] = useState<any>([]);
    const [showPaymentConfirmation, setShowPaymentConfirmation] = useState<boolean>(false);
    const [paymentConfirmationData, setPaymentConfirmationData] = useState<any>({ is_paid: '', paid_by: '' });
    const [showPaymentProofOptions, sethSowPaymentProofOptions] = useState<any>(WITH_UCF_PAYMENT_OPTION);
    const [sendToAgentPolicyShared, setsendToAgentPolicyShared] = useState((props.templateType === "customer") ? true : false);
    const [sendToSfaPolicySharedToAgencyOfficer, setsendToSfaPolicySharedToAgencyOfficer] = useState((props.templateType === "customer") ? true : false);
    const [selectedTab, setSelectedTab] = useState("first")
    const {translations} = useLanguage();
    const [fields, setFields] = useState<any>({});

    const [errField, setErrField] = useState<any>({
        is_paid: "",
        paid_by: "",
    });
    const [policyShareModal, setPolicyShareModal] = useState<any>(false);
    const navigate = useNavigate();
    const dispatch: any = useDispatch();

    const commonState = useSelector((state: any) => state.common);
    const insuranceState = useSelector((state: any) => state.insurance);
    const commission_type_list = commonState?.common?.commision_rate || [];
    const [commissionData, setCommissionData] = useState<any>({commission_type: "", bi_pd_value: "", commission_rate: ""});
    const [showBiPd, setShowBiPd] = useState<boolean>(false);  

    const branchList = commonState?.common?.branch_name?.filter((item: any) => +item?.insurer_id === +insuranceState?.leadDetail?.insurer_id && +item?.status === STATUS_FIELD.ACTIVE) || []; 
    const templateType:number = props.templateType === "broker"?TEMPLATE_TYPE_BROKER:TEMPLATE_TYPE_POLICY_SHARED;
    
    const branchData:Record<string,any> = insuranceState?.leadDetail?.sharedTemplateData?.find((item: any) => +item.type === templateType);
    
    const branchId:number = branchData?.branch_id || insuranceState?.leadDetail?.branch_id

    

    let disableBranchDropdown:boolean = false;
    if(
        templateType ===TEMPLATE_TYPE_BROKER 
        && branchData?.is_details_sent === TEMPLATE_TYPE_BROKER
        || branchData?.is_skipped === TEMPLATE_TYPE_BROKER
    ){
        disableBranchDropdown = true;
    }
    if(
        templateType ===TEMPLATE_TYPE_POLICY_SHARED 
        && branchData?.is_policy_shared_agent === TEMPLATE_TYPE_BROKER
    ){
        disableBranchDropdown = true;

    }
    
     

    useEffect(() => {
        //IN CASE OF POLICY SHARED SHOW PAYMENT PROOF POPUP
        if (props.templateType === "customer" && insuranceState.leadDetail) {
            if (insuranceState.leadDetail && insuranceState.leadDetail.application_type_id && !insuranceState.leadDetail.inbound_payment_from && props.activeTab === "first" && !insuranceState.getInboundPaymentFrom && insuranceState.leadDetail.status_id !== STATUS_SUB_STATUS['status']['lost']) {
                //FOR AGENCY IF POLICY SHARE THEN SHOW PAYMENT PROOF POPUP 
                if ([APP_TYPE_AGENCY].includes(insuranceState.leadDetail.application_type_id)) {
                    if (+insuranceState?.leadDetail?.sub_status_id === +STATUS_SUB_STATUS['subStatus']['policy_shared']) {
                        sethSowPaymentProofOptions(AGENCY_PAYMENT_OPTION);
                        //setShowPaymentConfirmation(true);
                    }
                } else {

                    if (!insuranceState.leadDetail.policy_shared_customer_source) {

                        //IN CASE OF WITH UCF
                        if (+insuranceState.leadDetail.application_type_id === APP_TYPE_WITH_UCF) {
                            sethSowPaymentProofOptions(WITH_UCF_PAYMENT_OPTION);
                            //setShowPaymentConfirmation(true);

                        } else { //IN CASE OF STANDALONE
                            sethSowPaymentProofOptions(STANDALONE_PAYMENT_OPTION);
                            //setShowPaymentConfirmation(true);
                        }
                    }
                }
            }
            //BY DEFAULT MARK FALSE FOR ARTEYO
            if(insuranceState.leadDetail.lead_type === APP_TYPE_ARTEYO){
                setsendToAgentPolicyShared(false);
            }

        //In case of without rule engine
            if(insuranceState.leadDetail.rule_engine_id === WITHOUT_RULE_ENGINE){   let bipdStatus=false;
                const {comm_rate, comm_type, bipd} = insuranceState.leadDetail;
                if (insuranceState?.leadDetail?.insurance_type_id!== INS_TYPE_CTPL) {
                    setCommissionData((prev: any) => ({...prev, commission_type: comm_type || "", commission_rate: comm_rate || "",  bi_pd_value: bipd === "" || bipd === undefined || bipd === null?'':bipd}));

                    bipdStatus=(bipd === "" || bipd === undefined || bipd === null)?false:true; 
                }else{
                    setCommissionData((prev: any) => ({...prev, commission_type: comm_type || 2, commission_rate: comm_rate || "",  bi_pd_value: bipd === "" || bipd === undefined || bipd === null?'':bipd}));
                }
                setShowBiPd(bipdStatus)
            }
        }
        // hide remark modal
        setPolicyShareModal(false);
    // }, [props.templateType, insuranceState.leadDetail.application_type_id, insuranceState.leadDetail.policy_shared_customer_source, insuranceState.leadDetail.inbound_payment_from]);
    // eslint-disable-next-line     
    }, [props.templateType, insuranceState.leadDetail]);

    useEffect(() => {
        setDocumentCategoryList(commonState.documentList);
    }, [commonState.documentList]);

    useEffect(() => {
        //IN CASE OF BROKER SET DATA
        if (insuranceState.leadDetail.policy_shared_broker_source && props.templateType === "broker") {

            let savedShareValues = insuranceState.leadDetail.policy_shared_broker_source ? insuranceState.leadDetail.policy_shared_broker_source.split(",") : [];

            let switchValueUpdated = savedShareValues.map((elm: any) => { return (+elm === SHARE_METHOD["email"]) ? "email" : ((+elm === SHARE_METHOD["whatsapp"]) ? "whatsapp" : ((+elm === SHARE_METHOD["viber"]) ? "viber" : "")) });

            setSwitchValue([...switchValueUpdated]);

            let savedShareDocuments = insuranceState.leadDetail.policy_shared_broker_documents ? insuranceState.leadDetail.policy_shared_broker_documents.split(",").map((elm: any) => +elm) : [];
            setSelectedDocType([...savedShareDocuments]);
        }

        //IN CASE OF CUSTOMER SET DATA
        if (insuranceState.leadDetail.policy_shared_customer_source && props.templateType === "customer") {

            let savedShareValues = insuranceState.leadDetail.policy_shared_customer_source ? insuranceState.leadDetail.policy_shared_customer_source.split(",") : [];

            let switchValueUpdated = savedShareValues.map((elm: any) => { return (+elm === SHARE_METHOD["email"]) ? "email" : ((+elm === SHARE_METHOD["whatsapp"]) ? "whatsapp" : ((+elm === SHARE_METHOD["viber"]) ? "viber" : "")) });
            setSwitchValue([...switchValueUpdated]);

            let savedShareDocuments = insuranceState?.leadDetail?.policy_shared_customer_documents?.split(",").map((elm: any) => +elm) || [];
            setSelectedDocType([...savedShareDocuments]);
        }

        //FOR STANDALONE
        if (insuranceState.leadDetail && +insuranceState.leadDetail.application_type_id === APP_TYPE_STANDALONE) {
            sethSowPaymentProofOptions(STANDALONE_PAYMENT_OPTION);
        }
        // eslint-disable-next-line
    }, [insuranceState.leadDetail]);

    useEffect(() => {
        //SET FIRST SUBMIT DOCUMENTS
        if (props.getDocumentsIds.firstSubmit) {
            let getFirstSubmitDocs: any = []
            for (let parent of documentCategoryList) {
                if (parent?.child.length) {
                    let parentArray: any = {};
                    //CHECK IN CHILD DOCS
                    for (let childs of parent.child) {
                        if (props.getDocumentsIds.firstSubmit.includes(+childs.value)) {
                            parentArray = JSON.parse(JSON.stringify(parent));
                            break;
                        }
                    }
                    //FILTER MATCHED CHILDS
                    if (parentArray.child) {

                        parentArray['child'] = parentArray.child.filter((ch: any) => props.getDocumentsIds.firstSubmit.includes(+ch.value));
                        getFirstSubmitDocs.push(parentArray);
                    }

                } else {
                    //CHECK IN PARENT 
                    if (props.getDocumentsIds.firstSubmit.includes(+parent?.value)) getFirstSubmitDocs.push(parent);
                }
            }

            getFirstSubmitDocs = getFirstSubmitDocs.map((doc: any) => {
                let newDoc = { 
                    ...doc, 
                    label: translations.Insurance?.[doc.label] || translations.commonMsg?.loading 
                };
    
                if (newDoc.child && Array.isArray(newDoc.child) && newDoc.child.length > 0) {
                    newDoc.child = newDoc.child.map((childDoc: any) => ({
                        ...childDoc,
                        label: translations.Insurance?.[childDoc.label] || translations.commonMsg?.loading
                    }));
                }
    
                return newDoc;
            });
            setShowFirstSubmitDocs([...getFirstSubmitDocs]);
        }
        //SET FIRST DISBURSAL DOCUMENTS
        if (props.getDocumentsIds.disbursal) {
            let getDisbursalDocs = documentCategoryList.filter((elm: any) => props.getDocumentsIds.disbursal.includes(+elm?.value));
            getDisbursalDocs = getDisbursalDocs.map((doc: any) => {
                let newDoc = { 
                    ...doc, 
                    label: translations.Insurance?.[doc.label] || translations.commonMsg?.loading 
                };
    
                if (newDoc.child && Array.isArray(newDoc.child) && newDoc.child.length > 0) {
                    newDoc.child = newDoc.child.map((childDoc: any) => ({
                        ...childDoc,
                        label: translations.Insurance?.[childDoc.label] || translations.commonMsg?.loading
                    }));
                }
    
                return newDoc;
            });
            setShowDisbursalDocs([...getDisbursalDocs]);
        }
    }, [props.getDocumentsIds, documentCategoryList,translations]);

    const handleButtonChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSwitchValue((prevSwitchValue) =>
            event.target.checked
                ? [...prevSwitchValue, event.target.value]
                : prevSwitchValue.filter((el) => el !== event.target.value)
        );
    };


    const changeDocTypeHandler = (e: React.ChangeEvent<HTMLInputElement>, doc: any, subType: string | null = null) => {
        let updatedSelectedDocType: any = selectedDocType;

        if(COUNTRY_CODE === 'id' && subType=== 'veh_condition_details' && COND_SHOW_FIELDS_ACC_INSURERS.includes(insuranceState?.leadDetail?.insurer_id) && props.templateType === "broker"){
            const value = e.target.value;
            const updatedField = {...fields}
            updatedField.veh_condition_details = value !== null || value === '' ? value : insuranceState?.leadDetail?.veh_condition_details;
            if(updatedField.veh_condition_details !== "" || updatedField.veh_condition_details !== null || updatedField.veh_condition_details !== undefined){
               delete updatedField.veh_condition_details_error;
            }
            setFields(updatedField);
            
        }else{

            if (e.target.checked) {
    
                if (!doc.child.length) {
                    updatedSelectedDocType.push(doc.value);
                }
                for (let child of doc.child) {
                    updatedSelectedDocType.push(child.value);
                }
            } else {
                updatedSelectedDocType = updatedSelectedDocType.filter((val: any) => +val !== +doc.value);
    
                if (doc.child.length) {
                    let getChilds = doc.child.map((c: any) => c.value);
                    updatedSelectedDocType = updatedSelectedDocType.filter((val: any) => !getChilds.includes(val));
    
                }
            }
    
            setSelectedDocType([...updatedSelectedDocType]);
        }
    };
    

    let policy_type_id = (COUNTRY_CODE === 'id' && insuranceState?.leadDetail?.policy_type_id) 
    ? insuranceState.leadDetail.policy_type_id 
    : POLICY_HOLDER['PERSONAL'];

    // function of validation RequiredField
    const validationRequiredField = () => {
        const { customer_name, mobile, email, payment_method_id, payment_term_id, per_house_no, per_street, per_region, per_city, per_barangay, per_postal_code, plate_no, fuel_type, is_under_financing, insurance_policy_exists, vehicle_seat, insurance_type_id, mv_number, pay_tenure, expected_installment, lead_source, referrer_mobile, referrer_name, lead_sub_source, application_type_id, paid_by_customer, premium_amount, premium_amount_date,gender,marital_status,per_housing,per_rt,per_rw,per_province,per_district,per_sub_district,vehicle_type,plate_area,plate_number_region,make,model,version,make_year,machine_number,chassis_number,vehicle_usage,vehicle_condition_id,tenure,insurance_starting_date} = insuranceState.leadDetail;
        // expected date validation
        if (pay_tenure && application_type_id === APP_TYPE_STANDALONE && payment_term_id === INSTALLMENT) {
            const months = parseInt(pay_tenure.split(' ')[0], 10);
            // Check each installment date
            for (let i = 1; i <= months; i++) {
                if (!expected_installment || (expected_installment && !expected_installment[i])) {
                    toast.error("All fields are required.")
                    return false;
                }
            }
        }
        if (COUNTRY_CODE === 'id') {
            
            
            if (
                !customer_name || (![APP_TYPE_AGENCY].includes(application_type_id) && !mobile) ||
                !per_housing || !per_rt || !per_rw || !per_city || !per_province || !per_district || !per_sub_district || !vehicle_type||!plate_area ||!plate_number_region||!make||!model||!version||!make_year||!machine_number||!chassis_number ||!plate_no || !vehicle_usage || !vehicle_condition_id || !insurance_type_id || !tenure || !insurance_starting_date) {  
                if(policy_type_id!==POLICY_HOLDER['COMPANY'] && (![APP_TYPE_AGENCY].includes(application_type_id) && (!gender || !marital_status))){
                    toast.error("All fields are required. Please fill in all the Customer Details.");
                    return;
                }
            }

            if(COND_SHOW_FIELDS_ACC_INSURERS.includes(insuranceState?.leadDetail?.insurer_id) && props.templateType === "broker"){
                if(!fields.veh_condition_details && !insuranceState?.leadDetail?.veh_condition_details){
                    const updatedField = {...fields}
                    updatedField.veh_condition_details_error = translations.commonMsg?.required;
                    setFields(updatedField);
                    return;
                }
            }
        }else{
            if (
                !customer_name || (![APP_TYPE_AGENCY].includes(application_type_id) && !mobile) || (![APP_TYPE_AGENCY].includes(application_type_id) && (!email || !payment_method_id || !payment_term_id || !per_house_no || !per_street )) ||
                 !per_region || !per_city || !per_barangay || !per_postal_code ||
                !fuel_type || !is_under_financing || !insurance_policy_exists || !vehicle_seat ||
                (![APP_TYPE_AGENCY].includes(application_type_id) && !lead_source) || ([APP_TYPE_STANDALONE, APP_TYPE_RENEWAL].includes(application_type_id) && +paid_by_customer === 1 && (!premium_amount || (!pay_tenure && !premium_amount_date))
                )
            ) {
                toast.error("All fields are required. Please fill in all the Customer Details.");
                return;
            }
        }
        if (premium_amount && premium_amount > insuranceState?.leadDetail?.car_fmv) {
            toast.error("Total Premium Amount should not be greater than FMV")
            return;
        }
        // for CTPL plate no or mv number required
        if (+insurance_type_id === INS_TYPE_CTPL && (!plate_no && !mv_number)) {
            toast.error("All fields are required. Please fill plate no or mv number");
            return false;
        }
        // Check if any of the required fields are empty        
        if (ALLOW_LEAD_SOURCE.includes(lead_source) && ((!referrer_mobile || (''+referrer_mobile)?.trim() === "") && (!referrer_name || (''+referrer_name)?.trim() === "")) && COUNTRY_CODE !== 'id') {            
            toast.error("All fields are required. Please fill in all the Other Details.");
            return false;
        }
        if (+lead_source === DSA_LEAD_SOURCE && (!referrer_name || referrer_name.trim() === "") && COUNTRY_CODE !== 'id') {
            toast.error("All fields are required. Please fill in all the Other Details.");
            return false;
        }
        if (+lead_source === MARKETING_LEAD_SOURCE && !lead_sub_source && COUNTRY_CODE !== 'id') {
            toast.error("All fields are required. Please fill in all the Other Details.");
            return false;
        }
        return true;
    };


    const isMarkAsApprovedAllow: boolean = insuranceState?.leadDetail?.images?.some((e: any) => e.action_status === ACTION_STATUS);

    const decodeHtmlEntities = (value: string) => {
        if (!value) return "";

        const parser = new DOMParser();
        return parser.parseFromString(value, "text/html").documentElement.textContent || "";
    };

    const sanitizeWhatsappMessage = (htmlContent: string) => {
        if (!htmlContent) return "";

        const blockLevelTags = [
            "address", "article", "aside", "blockquote", "br", "caption", "dd", "div", "dl", "dt",
            "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6",
            "header", "hr", "li", "main", "nav", "ol", "p", "pre", "section", "table", "tbody", "td",
            "tfoot", "th", "thead", "tr", "ul"
        ];

        const blockTagPattern = new RegExp(`</?(?:${blockLevelTags.join("|")})\\b[^>]*>`, "gi");

        const sanitizedText = htmlContent
            .replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, "")
            .replace(blockTagPattern, "\n")
            .replace(/<[^>]+>/g, " ")
            .replace(/&nbsp;/gi, " ");

        return decodeHtmlEntities(sanitizedText)
            .replaceAll(PHILIPPINE_CURRENCY, CURRENCY_SYMBOL)
            .replace(/\r\n/g, "\n")
            .replace(/[ \t]+\n/g, "\n")
            .replace(/\n[ \t]+/g, "\n")
            .replace(/[ \t]{2,}/g, " ")
            .replace(/\n{3,}/g, "\n\n")
            .trim();
    };

    const getWhatsappTemplateForSend = () => {
        if (COUNTRY_CODE !== 'id') return props.templateData;

        const selectedBranchId = +(commissionData?.branch?.value || branchId || insuranceState?.leadDetail?.branch_id || 0);
        const templateSources = [
            insuranceState?.leadDetail?.sharedTemplateData,
            insuranceState?.leadTemplateData,
            props?.insuranceDetails?.sharedTemplateData,
        ];

        const getMatchingTemplate = (templates: any[] = [], language?: string) => {
            let filteredTemplates = templates
                .map((template: any) => ({
                    template_type: +(template?.template_type ?? template?.source ?? 0),
                    template_for: +(template?.template_for ?? template?.type ?? 0),
                    description: template?.description ?? template?.template_text ?? "",
                    note: template?.note || "",
                    language: `${template?.language || ''}`.toLowerCase(),
                    branch_id: +(template?.branch_id || 0),
                }))
                .filter((template: any) =>
                    +template.template_type === 2 && +template.template_for === +templateType
                );

            if (props.templateType === "broker") {
                filteredTemplates = filteredTemplates.filter((template: any) => +template.branch_id === selectedBranchId);
            }

            if (language) {
                return filteredTemplates.find((template: any) => template.language === language && template.description);
            }

            return filteredTemplates.find((template: any) => template.description);
        };

        const matchedIdTemplate = templateSources
            .map((templates: any) => getMatchingTemplate(templates, 'id'))
            .find((template: any) => template?.description);

        const matchedFallbackTemplate = templateSources
            .map((templates: any) => getMatchingTemplate(templates))
            .find((template: any) => template?.description);

        const finalTemplate = matchedIdTemplate || matchedFallbackTemplate;

        if (!finalTemplate?.description) return props.templateData;

        return finalTemplate.note
            ? `${finalTemplate.description}<br/><br/>Note: ${finalTemplate.note}`
            : finalTemplate.description;
    };
    

    /**
     * SUBMIT HANDLER
     * @returns 
     */
    const submitHandler = async (params: any) => {
        //CHECK FIRST SUBMIT DOC STATUS
        if (props.templateType === "broker") {

            //IF BROKER ALREADY SKIPPED THEN NAVIGATE
            if (insuranceState.leadDetail.application_type_id === APP_TYPE_AGENCY && (params?.sent_to_broker_skip && (insuranceState.leadDetail.is_policy_shared_broker_skipped || insuranceState.leadDetail.policy_shared_broker_source))) {
                navigate(`/details/soft-approval-received/${insuranceState.leadDetail.hashId}`);
                return false;
            }

            const isValid = await validationRequiredField()

            if (!isValid) {
                return false;
            }

            if (+insuranceState.leadDetail.sub_status_id === 3) {
                toast.error("Currently lead is under approval for Sales Manager.");
                return false;
            }


            let mandatoryDocUploaded = true;
            if (commonState && commonState.documentList) {
                let documentList: any = JSON.parse(JSON.stringify(commonState.documentList))

                let docList = documentList.filter((docs: any) => +docs.doc_type_id === DOCUMENT_CATEGORY['firstSubmit']['doc_type_id']) //GET FIRST SUBMIT DOCS

                let uploadedImages = insuranceState.leadDetail.images.map((doc: any) => doc.doc_id);
                let conditionalMandatoryDocs: any = []
                //IN DOC LIST MATCH NOT UPLOADED DOCS
                for (let docs of docList) {
                    if (docs.conditional_mandatory && docs.conditional_mandatory.length) conditionalMandatoryDocs.push(+docs.value) //PUSH CONDITIONAL MANDATORY DOCS
                    if (!uploadedImages.includes(docs.value) && docs.is_required && +docs.value !== 4 && +docs.value !== 27 && COUNTRY_CODE!== 'id') { //SKIP VEHICLE

                        mandatoryDocUploaded = false;
                        break;
                    } else if (docs?.child?.length) { //CHECK MANFATORY IMAGES                        
                        //FOR VEHICLE DOC CHILDS
                        for (let childdoc of docs.child) {
                            if (childdoc.is_required && !uploadedImages.includes(childdoc.value)) {
                                mandatoryDocUploaded = false;
                            }
                        }
                    }
                }
                //check if any conditional mandatory doc is not uploaded
                let uploadedConditionalMandDocs = uploadedImages && uploadedImages.filter((e: any) => conditionalMandatoryDocs.includes(e))
                if (conditionalMandatoryDocs.length && (!uploadedConditionalMandDocs || !uploadedConditionalMandDocs.length)) mandatoryDocUploaded = false

                if(COUNTRY_CODE==='id'){

                    const docsIds:Number[] = docList.map((doc: any) => doc.value);
                    const allExist = VEHICLE_CHILD_IDS.every(id =>
                        uploadedImages.includes(id)
                    );
                    if(
                        (uploadedImages?.includes(EXISTING_POLICY_DOC_ID) && docsIds?.includes(VEHICLE_DOC_ID))
                        || (allExist && docsIds?.includes(EXISTING_POLICY_DOC_ID))
                    ){
                        mandatoryDocUploaded = true
                    }
                }
            }
            
            if (!mandatoryDocUploaded) {
                toast.error("Please upload all mandatory documents");
                return false;
                
            }
            if (+insuranceState.leadDetail.doc_status_id !== 3 || isMarkAsApprovedAllow) {
                toast.error("Please approve all documents");
                return false;

            }
        }

        //IN CASE OF UCF ASK PAYMENT PROOF
        // if (insuranceState.leadDetail && !insuranceState.leadDetail.inbound_payment_from && props.templateType === "customer" && (paymentConfirmationData['is_paid'] !== "yes" || (paymentConfirmationData['is_paid'] === "yes" && paymentConfirmationData['paid_by'] === "")) && !insuranceState.getInboundPaymentFrom && ![APP_TYPE_AGENCY].includes(insuranceState.leadDetail.application_type_id) && (COUNTRY_CODE!=='id')) {
        //     //setShowPaymentConfirmation(true);
        //     return false;
        // }

        //CHECK POST DISBURSAL DOC STATUS
        if (props.templateType === "customer") {
            let getDisbursalDocs = insuranceState.leadDetail.images.filter((img: any) => +img.doc_type_id === DOCUMENT_CATEGORY['disbursal']['doc_type_id']);
            let getRequiredDisbursalDocs = insuranceState.leadDetail.images.filter((img: any) => +img.doc_type_id === DOCUMENT_CATEGORY['disbursal']['doc_type_id'] && +img.doc_id === DOCUMENT_CATEGORY['disbursal']['childs']['policy_shared']); //INSURANCE POLICY DOCUMENT REQUIRED
            let getApprovedDocs = getDisbursalDocs.filter((approved: any) => approved.doc_id && +approved.is_approved === 1);
            if(COUNTRY_CODE==='ph' && insuranceState?.leadDetail?.rule_engine_id === WITHOUT_RULE_ENGINE && !checkCommissionForm()){
                return false;
            }

            if (!getRequiredDisbursalDocs.length) {
                toast.error("Please upload all mandatory documents");
                return false;
            } else if (getApprovedDocs.length !== getDisbursalDocs.length) {
                toast.error("Please approve all Disbursal documents");
                return false;
            }
        }

        if (!props.emailTemplateExists && !props.whatsappTemplateExists && ((props.templateType === "broker" && !params.sent_to_broker_skip) || (props.templateType === "customer" && selectedTab === "second"))) {
            toast.error("Please create at least one template, either Email or WhatsApp.");
            return false;
        }
        if (!switchValue?.length && ((props.templateType === "broker" && !params.sent_to_broker_skip) || (props.templateType === "customer" && ((insuranceState.leadDetail.application_type_id === APP_TYPE_AGENCY && selectedTab === "second") || (props.templateType === "customer" && selectedTab === "first" && COUNTRY_CODE==='id')  || insuranceState.leadDetail.application_type_id !== APP_TYPE_AGENCY)))) {
            // if(props.templateType === "broker" && params.sent_to_broker_skip) return true;
            // if(props.templateType === "customer" && selectedTab === "first") return true;


            toast.error("Please select at least one of the source Email/Whatsapp");
            return false;
        }

        setLoading(true);

        let getDocumentUrls = [];
        let emailTempDocs = "";
        let openWhatsapp = false;
        let waMsg = "";

        //IF WA SELECTED THEN PREPARE MSG
        if (insuranceState.leadDetail && insuranceState.leadDetail.images && switchValue.includes("whatsapp")) {

            if ((props.templateType === "customer" && selectedTab === "first" && insuranceState.leadDetail.application_type_id === APP_TYPE_AGENCY && COUNTRY_CODE !== 'id')) {
                //SKIP FOR SEND TO SFA
            } else {

                openWhatsapp = true;
                getDocumentUrls = insuranceState.leadDetail.images.filter((docs: any) => selectedDocType.includes(+docs.doc_id));

                for (let doc of getDocumentUrls) {
                    if (doc.path.length) {
                        emailTempDocs += `${doc.doc_name}: \n`;
                        //emailTempDocs += `${doc.path} \n`;
                        emailTempDocs += `${doc.short_path || doc.path} \n`;

                    }

                }
                const whatsappTemplateForSend = getWhatsappTemplateForSend();
                let formatMsg = `${sanitizeWhatsappMessage(whatsappTemplateForSend)}\n\n${emailTempDocs}`.trim();
                waMsg = WHATSAPP_WEB_URL + encodeURIComponent(formatMsg);
                // console.log(waMsg)
            }
        }

        let paymentFrom = 0;
        if (insuranceState.getInboundPaymentFrom === "broker") {
            paymentFrom = 1;
        } else if (insuranceState.getInboundPaymentFrom === "sales_team") {
            paymentFrom = 2;
        } else if (insuranceState.getInboundPaymentFrom === "customer") {
            paymentFrom = 3;
        } else if (insuranceState.getInboundPaymentFrom === "oto_insurance") {
            paymentFrom = 4;
        } else if (insuranceState.getInboundPaymentFrom === "insurance_partner") {
            paymentFrom = 5;
        }
      
        let submitParams: any = { "source": switchValue, selectedDocType, leadId: insuranceState.leadDetail.hashId, type: (props.templateType === "broker") ? '1' : '2', payment_from: paymentFrom };

        if(
            COUNTRY_CODE === 'id' 
            && 
            COND_SHOW_FIELDS_ACC_INSURERS.includes(insuranceState?.leadDetail?.insurer_id)
            &&
            props.templateType === "broker"
        ){
           
            let value = fields.veh_condition_details ? fields.veh_condition_details : insuranceState?.leadDetail?.veh_condition_details;
            submitParams = { ...submitParams, veh_condition_details: value };
        }

        //REPLACE REQUEST DATA IF SENT TO BROKER SKIPPED
        if (params?.sent_to_broker_skip) {
            submitParams['source'] = undefined;
            submitParams['selectedDocType'] = undefined;
            submitParams = { ...submitParams, sent_to_broker_skip: 1 }

        }

        if (props.templateType === "customer" && selectedTab === "first" && insuranceState.leadDetail.application_type_id === APP_TYPE_AGENCY && COUNTRY_CODE!=='id') {

            if (!sendToAgentPolicyShared && !sendToSfaPolicySharedToAgencyOfficer) {
                if(insuranceState.leadDetail.lead_type === APP_TYPE_ARTEYO){
                    toast.error("Please select Send to Agency Officer");
                }else{
                    toast.error("Please select either Send to Agent or Send to Agency Officer");
                }
                setLoading(false);
                return false;
            }

            //IF CHECKED
            submitParams['source'] = undefined;
            submitParams['selectedDocType'] = undefined;
            submitParams = {
                ...submitParams,
                sendToAgentPolicyShared: sendToAgentPolicyShared ? 1 : 0,
                sendToSfaPolicySharedToAgencyOfficer: sendToSfaPolicySharedToAgencyOfficer ? 1 : 0,
            }
        }

        //In case of policy shared and without rule engine
        if(COUNTRY_CODE==='ph' && props.templateType === "customer" && insuranceState.leadDetail.rule_engine_id === 2){   
            submitParams = {
                ...submitParams,
                commission_type: Number(commissionData?.commission_type) || "",
                bi_pd_value:(commissionData?.bi_pd_value === "" || commissionData?.bi_pd_value === undefined || commissionData?.bi_pd_value === null ? "" : Number(commissionData?.bi_pd_value)),
                commission_rate: Number(commissionData?.commission_rate) || "",
            };
        
        }
        if(COUNTRY_CODE==='id' && props.templateType === "broker" && !commissionData?.branch){
            const errors = structuredClone(errField)
            errors.branch = translations?.EMAIL_TEMPLATE?.SELECT_BRANCH
            setErrField(errors)
            setLoading(false);
            return false;
        }
        if(COUNTRY_CODE==='id' && props.templateType === "broker" && +commissionData.branch?.value){
            submitParams.branch_id = +commissionData.branch?.value
        }
        
        sharePolicyDetails(submitParams).then((res: any) => {
            setLoading(false);
            if (res.status === STATUS_SUCCESS) {
                // here with payload pass for fetching other details document
                const payload: any = {
                    leadId: insuranceState.leadDetail.hashId,
                    source: 'web'
                };
               dispatch(setIsBrokerSent(true));

                //** Filter gate document images based on policyholder type, vehicle condition ID, existing policy, vehicle photos, and comments
                if(INS_INSURANCE_ID_STAGE){                              
                    payload.lead_id = insuranceState?.leadDetail?.id;
                }
                //** Filter gate document images based on policyholder type, vehicle condition ID, existing policy, vehicle photos, and comments


                dispatch(getDocumentListing(payload));

                if (res.data && Object.keys(res.data).length) {
                    
                    if(
                        COUNTRY_CODE === 'id' 
                        && 
                        COND_SHOW_FIELDS_ACC_INSURERS.includes(insuranceState?.leadDetail?.insurer_id)
                        &&
                        props.templateType === "broker"
                        &&
                        insuranceState?.leadDetail?.lead_tenure_data?.length === 1
                    ){
                        res.data.sent_to_verification = SENT_TO_VERIFICATION.DONE
                    }

                    dispatch(updateLeadDetailsInStore({ ...insuranceState.leadDetail, ...res.data }));
                }

                if (props.templateType === "broker") {
                    if(COUNTRY_CODE==='id'){
                        navigate(`/details/insurance-policy-generated/${insuranceState.leadDetail.hashId}`);
                    }else{
                        navigate(`/details/soft-approval-received/${insuranceState.leadDetail.hashId}`);
                    }
                   
                } else if (props.templateType === "customer" && COUNTRY_CODE!=='id') { //WITH UCF AND INBOUND PAYMENT FROM CUSTOMER                  

                    //IN CASE OF AGENCY
                    // if (+insuranceState.leadDetail.application_type_id === APP_TYPE_AGENCY) {

                    //     //IN CASE OF UCF ASK PAYMENT PROOF
                    //     // if (insuranceState.leadDetail && !insuranceState.leadDetail.inbound_payment_from && props.templateType === "customer" && (paymentConfirmationData['is_paid'] !== "yes" || (paymentConfirmationData['is_paid'] === "yes" && paymentConfirmationData['paid_by'] === "")) && !insuranceState.getInboundPaymentFrom && ![APP_TYPE_AGENCY].includes(insuranceState.leadDetail.application_type_id)) {
                    //     if (!insuranceState.leadDetail.inbound_payment_from) {

                    //         //setShowPaymentConfirmation(true);
                    //         sethSowPaymentProofOptions(AGENCY_PAYMENT_OPTION);
                    //     } else {
                    //         if ([INBOUND_PAYMENT_FROM_OTO_INSURANCE].includes(+insuranceState.leadDetail.inbound_payment_from)) {
                    //             navigate(`/details/payment-from-agency-to-oto-insurance/${insuranceState.leadDetail.hashId}`);

                    //         } else { //insurance_partner
                    //             navigate(`/details/payment-from-agency-to-insurance-partner/${insuranceState.leadDetail.hashId}`);

                    //         }
                    //     }

                    //     // return false;
                    //     // }


                    // }else {
                    //     if (paymentConfirmationData['paid_by'] === "customer" || [INBOUND_PAYMENT_FROM_CUSTOMER].includes(+insuranceState.leadDetail.inbound_payment_from)) {
                    //         navigate(`/details/payment-customer/${insuranceState.leadDetail.hashId}`);
                    //     } else {
                    //         navigate(`/details/payment-from-customer-to-partner-broker/${insuranceState.leadDetail.hashId}`);
                    //     }
                    // }
                }else{
                    if(COUNTRY_CODE==='id'){
                        navigate(`/details/insurance-policy-shared/${insuranceState.leadDetail.hashId}`);
                    }else{
                        navigate(`/details/insurance-premium-payment/${insuranceState.leadDetail.hashId}`);
                    }
                }

                if (openWhatsapp) window.open(waMsg, '_blank', 'noreferrer');
            }

        }).catch((err: any)=>{
            console.log('err----',err)
            setLoading(true);
        })

    }

    /**
     * PAYMENT PROOF 
     * @param e 
     * @param key 
     */
    const changeHandler = (e: any, key: string) => {
        // let paymentConfirmationData        
        if (key === "commission_type") {
            setCommissionData((prev: any) => ({ ...prev, [key]: e.value }));
            if([3,4].includes(e.value)){
                setShowBiPd(true);
            } else {
                setShowBiPd(false);
            }
            setErrField((prev: any) => ({...prev, [key]: ""}));
        } else if (['commission_rate', 'bi_pd_value'].includes(key)){
            setCommissionData((prev: any) => ({ ...prev, [key]: e }));
            setErrField((prev: any) => ({...prev, [key]: ""}));
        } else if(key === "branch") {
            setCommissionData((prev: any) => ({ ...prev, [key]: e }));
            setErrField((prev: any) => ({...prev, [key]: ""}));
            dispatch(updateLeadDetailsInStore({ ...insuranceState.leadDetail, branch_id: e?.value }));
        }
        else {
            setPaymentConfirmationData({ ...paymentConfirmationData, [key]: e ? e.value : "" })
            errField[key] = '';
            setErrField({ ...errField });
        }


    }

    /**
     * PAYMENT FROM CONFIRMATION HANDLER
     */
    const paymentConfirnationHandler = () => {
        if (validForm()) {
            if (paymentConfirmationData['is_paid'] === "yes" && paymentConfirmationData['paid_by']) {
                // props.setInboundPaymentFrom(paymentConfirmationData['paid_by']);
                dispatch(setInboundPaymentFromResponse(paymentConfirmationData['paid_by']));

                //IF PAYMENT DONE TO BROKER THEN SHARE DOCs
                let applicationType = +insuranceState.leadDetail.application_type_id
                if ([APP_TYPE_AGENCY].includes(applicationType)) {

                    let navigationUrl = "insurance-policy-shared";

                    if (paymentConfirmationData['paid_by'] === "oto_insurance") {
                        navigationUrl = "payment-from-agency-to-oto-insurance";
                    } else { //insurance_partner
                        navigationUrl = "payment-from-agency-to-insurance-partner";
                    }

                    navigate(`/details/${navigationUrl}/${insuranceState.leadDetail.hashId}`);

                }
                else if (paymentConfirmationData['paid_by'] === "broker" || [APP_TYPE_STANDALONE, APP_TYPE_RENEWAL, APP_TYPE_WITH_UCF].includes(applicationType)) {
                    // submitHandler();
                } else {
                    let navigationUrl = "payment-customer";
                    if (paymentConfirmationData['paid_by'] === "broker") {
                        navigationUrl = "payment-broker";
                    } else if (paymentConfirmationData['paid_by'] === "sales_team") {
                        navigationUrl = "payment-sales-team";
                    }
                    navigate(`/details/${navigationUrl}/${insuranceState.leadDetail.hashId}`);
                }
            }
            //setShowPaymentConfirmation(false);
        }
    }

    //Validation 
    const validForm = () => {
        let formIsValid = true;
        setErrField({
            is_paid: "",
            paid_by: "",
        });

        if (paymentConfirmationData.is_paid === "") {
            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                is_paid: "This field is required",
            }));
        }
        if (paymentConfirmationData.paid_by === "") {
            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                paid_by: "This field is required",
            }));
        }

        return formIsValid;
    };

    useEffect(() => {
        //IN CASE OF AGENCY SHOW PAYMENT POPUP AFTER POLICY SHARED
        if (props.templateType === "customer" && +insuranceState.leadDetail.application_type_id === APP_TYPE_AGENCY && insuranceState.leadDetail.sub_status_id === +STATUS_SUB_STATUS['subStatus']['policy_shared'] && !showPaymentConfirmation && !insuranceState.leadDetail.inbound_payment_from) { //WITH UCF AND INBOUND PAYMENT FROM CUSTOMER    
            sethSowPaymentProofOptions(AGENCY_PAYMENT_OPTION);
            //setShowPaymentConfirmation(true);

        }
        // eslint-disable-next-line
    }, [props])

    const checkCommissionForm = () => {
        let formIsValid = true;
        
        setErrField({
            commission_type: "",
            bi_pd_value: "",
            commission_rate: ""
        });

        if (commissionData.commission_type === "") {
            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                commission_type: "This field is required",
            }));
        }

        if (showBiPd && commissionData.bi_pd_value === "") {
            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                bi_pd_value: "This field is required",
            }));
        }

        if (commissionData.commission_rate === "") {
            formIsValid = false;
            setErrField((prevState: any) => ({
                ...prevState,
                commission_rate: "This field is required",
            }));
        }
        return formIsValid;
    } 

    useEffect(() => {
        const leadBranchId = insuranceState?.leadDetail?.branch_id;
        if (!leadBranchId) return;

        const desiredBranchId = +(branchData?.branch_id || 0) || +leadBranchId;
        const currentBranchId = commissionData?.branch?.value ? +commissionData.branch.value : 0;

        // Initialize once; if sharedTemplateData arrives later, upgrade from lead branch -> shared branch.
        if (!currentBranchId || (currentBranchId === +leadBranchId && desiredBranchId !== currentBranchId)) {
            setCommissionData((prev: any) => ({
                ...prev,
                branch: { value: desiredBranchId }
            }));
        }
    }, [insuranceState?.leadDetail?.branch_id, branchData?.branch_id, commissionData?.branch?.value]);

    useEffect(() => {
        if(props?.setSelectedBranchId){
            props.setSelectedBranchId(+(commissionData?.branch?.value || 0));
        }
    }, [commissionData?.branch?.value]);

    const renderForm = () => {
        return (   
            <>
                {
                    COUNTRY_CODE ==='id' && props.templateType === "broker" && (
                        <div className='row'>
                                <div className='col-md-7'>
                                    <ReactSelect
                                        options={branchList}
                                        value={
                                            branchList?.find(
                                                (item: any) =>
                                                item.value === (commissionData?.branch?.value
                                                    ? +commissionData.branch.value
                                                    : branchId)
                                            ) || ''
                                        }
                                        handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)}
                                        placeholder={translations?.BRANCH_CONFIG?.BRANCH}
                                        fieldKey="branch"
                                        errorField={errField.branch}
                                        isDisabled={disableBranchDropdown}
                                    />
                                </div>
                        </div>
                    )
                }
                {(props.emailTemplateExists || props.whatsappTemplateExists) &&
                    (
                        <fieldset className="from-group">
                            {
                                props.emailTemplateExists &&
                                <div className="custom-control custom-checkbox">
        
                                    <input
                                        id="email"
                                        type="checkbox"
                                        onChange={handleButtonChange}
                                        className="custom-control-input "
                                        name="send-method-email"
                                        value={"email"}
                                        checked={(switchValue.includes("email"))}
                                    />{" "}
                                    <label className="custom-control-label">Email </label>
                                </div>
                            }
        
                            {
                                props.whatsappTemplateExists &&
                                <div className=" custom-control custom-checkbox">
                                    <input
                                        id="whatsapp"
                                        type="checkbox"
                                        onChange={handleButtonChange}
                                        name="send-method-wa"
                                        value={"whatsapp"}
                                        className="custom-control-input"
                                        checked={(switchValue.includes("whatsapp"))}
        
                                    />{" "}
                                    <label className="custom-control-label">Whatsapp</label>
                                </div>
                            }
        
                            <div className=" custom-control custom-checkbox" style={{ "visibility": "hidden" }}>
                                <input
                                    id="viber"
                                    type="checkbox"
                                    onChange={handleButtonChange}
                                    name="send-method-viber"
                                    value={"viber"}
                                    className="custom-control-input"
                                    checked={(switchValue.includes("viber"))}
        
                                />{" "}
                                <label className="custom-control-label">Viber</label>
                            </div>
    
                        </fieldset>
                    )
                }
                <div className='doc-attech-heading'>
                    <h3>{translations.Insurance?.['Documents Attached'] || translations.commonMsg?.loading}</h3>
                </div>
                <div className="lead-form-filed send-financer">

                    <div className="financer-doc-list">
                        <Tab.Container id="left-tabs-example" defaultActiveKey={(props.templateType === "broker") ? "first" : (props.templateType === "customer" ? "second" : "third")}>
                            <Nav variant="pills" className="flex-column tab-line">
                                <div className="tab-list">

                                    <Nav.Item>
                                        <Nav.Link eventKey="first">{translations.Insurance?.['First Submit'] || translations.commonMsg?.loading}</Nav.Link>
                                    </Nav.Item>
                                    {
                                        props.templateType === "customer" &&
                                        <Nav.Item>
                                            <Nav.Link eventKey="second">{translations.Insurance?.['Disbursal'] || translations.commonMsg?.loading}</Nav.Link>
                                        </Nav.Item>
                                    }

                                </div>
                            </Nav>

                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <div className='contentWrapperList insurance-broker-doc-attech-list'>

                                        {
                                            showFirstSubmitDocs.length > 0 && showFirstSubmitDocs.map((doc: any, key: number) =>

                                                doc.child.length ?

                                                    <Accordion allowZeroExpanded key={doc.label}>


                                                        <AccordionItem >
                                                            <AccordionItemHeading>
                                                                <AccordionItemButton>
                                                                    <div className=" custom-control custom-checkbox">
                                                                        <input
                                                                            id="pending"
                                                                            type="checkbox"
                                                                            className="custom-control-input"
                                                                            onChange={(event) => changeDocTypeHandler(event, doc)}
                                                                            checked={doc.child.find((childs: any) => selectedDocType.includes(childs['value']))}
                                                                        />
                                                                        <label className="custom-control-label">{doc.label}</label>
                                                                    </div>
                                                                </AccordionItemButton>
                                                            </AccordionItemHeading>
                                                            <AccordionItemPanel>
                                                                <div className="sub-list">
                                                                    <ul className="">

                                                                        {
                                                                            doc.child.map((childCat: any, childKey: number) =>
                                                                                <li key={childCat.label}>
                                                                                    <div className=" custom-control custom-checkbox">
                                                                                        <input
                                                                                            id="pending"
                                                                                            type="checkbox"
                                                                                            className="custom-control-input"
                                                                                            onChange={(event) => changeDocTypeHandler(event, childCat)}
                                                                                            checked={selectedDocType.includes(childCat['value'])}

                                                                                        />
                                                                                        <label className="custom-control-label">{childCat.label}</label>
                                                                                    </div>
                                                                                </li>
                                                                            )
                                                                        }

                                                                    </ul>
                                                                </div>
                                                            </AccordionItemPanel>
                                                        </AccordionItem>



                                                    </Accordion>

                                                    :

                                                    <div className=" custom-control custom-checkbox" key={doc.label}>
                                                        <input
                                                            id="insurancepolicy"
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            onChange={(event) => changeDocTypeHandler(event, doc)}
                                                            checked={selectedDocType.includes(doc['value'])}

                                                        />
                                                        <label className="custom-control-label">{doc.label}</label>
                                                    </div>

                                            )
                                        }
                                    </div>
                                    {
                                        props.templateType === "broker" && COUNTRY_CODE === 'id' && COND_SHOW_FIELDS_ACC_INSURERS.includes(insuranceState?.leadDetail?.insurer_id) && (
                                            <div>
                                                <fieldset className="form-filed">
                                                <div className="material">
                                                    <h2>{translations?.Insurance?.['VEHICLE_COND_DETAIL']}*</h2>
                                                    <textarea 
                                                    placeholder=" " 
                                                    className="form-input" rows={3} 
                                                    value={fields.veh_condition_details || insuranceState?.leadDetail?.veh_condition_details}
                                                    onChange={(event:any) => changeDocTypeHandler(event, null, "veh_condition_details")}
                                                    >
                                                    </textarea>
                                                    {
                                                        fields?.veh_condition_details_error && <span className="error-txt">{fields?.veh_condition_details_error}</span>
                                                    }
                                                </div>
                                                </fieldset>
                                                {
                                                    insuranceState?.leadDetail?.comment &&
                                                    <div className="reupload-reason"><b>{translations?.Insurance?.MEGA_REJECT_RESON}:</b><br/>
                                                {insuranceState?.leadDetail?.comment}  </div>
                                                }
                                            </div>
                                        )
                                    }

                                </Tab.Pane>
                                {
                                    props.templateType === "customer" &&

                                    <Tab.Pane eventKey={"second"}>
                                        <div className='contentWrapperList'>


                                            {
                                                showDisbursalDocs.length > 0 && showDisbursalDocs.map((doc: any, key: number) =>
                                                    // <div className='approvalWrapper'>
                                                    <div className="custom-control custom-checkbox" key={doc.label}>
                                                        <input
                                                            id="insurancepolicy"
                                                            type="checkbox"
                                                            className="custom-control-input"
                                                            onChange={(event) => changeDocTypeHandler(event, doc)}
                                                            checked={selectedDocType.includes(doc['value'])}
                                                        //disabled={insuranceState.leadDetail.status_id >= 2}

                                                        />
                                                        <label className="custom-control-label">{doc.label}</label>
                                                    </div>
                                                    // {/* </div> */}
                                                )

                                            }

                                        </div>

                                    </Tab.Pane>

                                }

                            </Tab.Content>

                        </Tab.Container>

                    </div>
                </div>
            </>

        )
    }

    const sendToAgentHandler = () => {
        setsendToAgentPolicyShared(!sendToAgentPolicyShared)
    }

    const sendToAgentToAgencyOfficerHandler = () => {
        setsendToSfaPolicySharedToAgencyOfficer(!sendToSfaPolicySharedToAgencyOfficer)
    }

    const handleTabSelect = (eventKey: any) => {
        setSelectedTab(eventKey);
    }

    useEffect(() => {
        if (insuranceState?.leadDetail?.sub_status_id >= STATUS_SUB_STATUS['subStatus']['policy_shared']) {

            setsendToAgentPolicyShared(insuranceState?.leadDetail?.is_policy_shared_agent ? true : false)
        }
    // eslint-disable-next-line
    }, [insuranceState?.leadDetail?.is_policy_shared_agent])

    useEffect(() => {
        if (insuranceState?.leadDetail?.sub_status_id >= STATUS_SUB_STATUS['subStatus']['policy_shared']) {

            setsendToSfaPolicySharedToAgencyOfficer(insuranceState?.leadDetail?.is_policy_shared_to_agency_officer ? true : false)
        }
    // eslint-disable-next-line
    }, [insuranceState?.leadDetail?.is_policy_shared_agent])


    // set value for ctpl
    // useEffect(() => {
    //     console.log("insuranceState====",insuranceState.leadDetail);
    //     if (insuranceState?.leadDetail?.insurance_type_id === INS_TYPE_CTPL) {
    //         let commData:any={
    //             commission_type: 2,
    //             bi_pd_value: "",
    //             commission_rate: ""
    //         }
    //         setCommissionData(commData);
    //         setShowBiPd(false);
    //     }
    // }, [insuranceState?.leadDetail?.insurance_type_id]);

    return (

        <div className="form-tab-right-panel">
            <FullPageLoader show={loading} />

            <div className="lead-detail-from-outer">
                <div className={" switch-toggle"}>
                    <div className="lead-form-heading">

                        <h2>{props.title}</h2>

                        {
                            (
                                (
                                    (+insuranceState?.leadDetail?.application_type_id === APP_TYPE_AGENCY &&
                                        props.templateType === "broker" &&
                                        insuranceState?.leadDetail?.agency_id &&
                                        ![AGENCY_STATUS['inprogress'], AGENCY_STATUS['rejected']].includes(insuranceState?.leadDetail?.agency_status)
                                    ) ||
                                    (+insuranceState?.leadDetail?.application_type_id === APP_TYPE_WITH_UCF && props.templateType === "broker")
                                ) &&
                                !insuranceState?.leadDetail?.is_sent_to_broker &&
                                !insuranceState?.leadDetail?.policy_shared_broker_source?.trim() && 
                                +insuranceState?.leadDetail?.status_id !== STATUS_SUB_STATUS['status']['lost']
                            ) &&
                            // eslint-disable-next-line
                            <NavLink className="skip-txt" to="javascript:;" onClick={() => submitHandler({ sent_to_broker_skip: 1 })}>
                                Skip
                            </NavLink>
                        }  
                         
                    </div>
                    <div className="fe-status-form">

                        {
                            ((+insuranceState?.leadDetail?.application_type_id === APP_TYPE_AGENCY && !INS_INSURANCE_ID_STAGE) && props.templateType === "customer") ?
                                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                    <Nav variant="pills" className="flex-column tab-line" onSelect={(k) => handleTabSelect(k)}>
                                        <div className="tab-list">

                                            <Nav.Item>
                                                <Nav.Link eventKey="first">SFA App/Agent App</Nav.Link>
                                            </Nav.Item>
                                            {
                                                props.templateType === "customer" &&
                                                <Nav.Item>
                                                    <Nav.Link eventKey="second" disabled={insuranceState?.leadDetail?.lms_loan_id}>EMAIL/WHATSAPP</Nav.Link>
                                                </Nav.Item>
                                            }

                                        </div>
                                    </Nav>
                                    <Tab.Content className='m-xl-t'>
                                        <Tab.Pane eventKey="first">
                                            <fieldset className="from-group">
                                                <div className="custom-control custom-checkbox">

                                                    <input
                                                        id="policy_shared_sfa"
                                                        type="checkbox"
                                                        onChange={sendToAgentHandler}
                                                        className="custom-control-input "
                                                        name="send-method-email"
                                                        value={"policy_shared_agent"}
                                                        checked={sendToAgentPolicyShared && !insuranceState?.leadDetail?.lms_loan_id}
                                                        disabled={insuranceState?.leadDetail?.lms_loan_id || insuranceState?.leadDetail?.is_policy_shared_agent}
                                                    />{" "}
                                                    <label className="custom-control-label">Send to Agent</label>
                                                </div>
                                            </fieldset>

                                            <fieldset className="from-group">
                                                <div className="custom-control custom-checkbox">

                                                    <input
                                                        id="policy_shared_sfa_agency_officer"
                                                        type="checkbox"
                                                        onChange={sendToAgentToAgencyOfficerHandler}
                                                        className="custom-control-input "
                                                        name="send-method-email"
                                                        value={"policy_shared_sfa_agency_officer"}
                                                        checked={sendToSfaPolicySharedToAgencyOfficer}
                                                        disabled={insuranceState?.leadDetail?.is_policy_shared_to_agency_officer}
                                                    />{" "}
                                                    <label className="custom-control-label">Send to Agency Officer</label>
                                                </div>
                                            </fieldset>

                                        </Tab.Pane>

                                        <Tab.Pane eventKey="second">

                                            {
                                                renderForm()
                                            }

                                        </Tab.Pane>
                                    </Tab.Content>
                                </Tab.Container>
                                :
                                renderForm()
                        }

                    </div>
                    
                    {
                        COUNTRY_CODE !== 'id' && props.templateType === "customer" && insuranceState.leadDetail.rule_engine_id === WITHOUT_RULE_ENGINE && 
                        <div className='m-md-t m-md-b'>
                            <div className='doc-attech-heading'>
                                <h3>Commission Rate</h3>
                            </div>
                            <div className='row m-md-t'>
                                <fieldset className='col-md-5'>
                                    <div className='material'>
                                        <ReactSelect
                                            options={commission_type_list}
                                            value={commission_type_list?.find((item: any) => +item.value === +commissionData.commission_type) || ''}
                                            handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)}
                                            placeholder={"Commission Type"}
                                            fieldKey="commission_type"
                                            errorField={errField.commission_type}
                                            isDisabled={ insuranceState?.leadDetail?.insurance_type_id === INS_TYPE_CTPL || !HELPER.isUserHasUpdateAccess({ permissionID: ROLE_FEATURES['insurance_policy_shared'], accessType: 'edit', leadDetails: insuranceState.leadDetail, pageSlug: "policy_shared", selectedTab })}
                                        />
                                    </div>
                                </fieldset>

                                  {showBiPd && <fieldset className='col-md-5'>
                                        <fieldset className="">
                                            <div className='material'>
                                        <input
                                            type={"number"}
                                            placeholder=" "
                                            className="form-input"
                                            value={commissionData?.bi_pd_value === "" || commissionData?.bi_pd_value === undefined || commissionData?.bi_pd_value === null ? "" : commissionData?.bi_pd_value}
                                            onChange={(e) => changeHandler(e.target.value, 'bi_pd_value')}
                                            disabled={!HELPER.isUserHasUpdateAccess({ permissionID: ROLE_FEATURES['insurance_policy_shared'], accessType: 'edit', leadDetails: insuranceState.leadDetail, pageSlug: "policy_shared", selectedTab })}
                                        />
                                        <label data-label="BI/PD %" className="form-label"></label>
                                         {
                                        errField[`bi_pd_value`]
                                            ?
                                            <span className="error-txt">{errField[`bi_pd_value`]}</span>
                                            :
                                            ''
                                    }
                                    </div>
                                    </fieldset>
                                </fieldset>
                                }

                                <fieldset className='col-md-5'>
                                    <div className='material'>
                                        <input
                                            type={"number"}
                                            placeholder=" "
                                            className="form-input"
                                            value={commissionData?.commission_rate || ""}
                                            onChange={(e) => changeHandler(e.target.value, 'commission_rate')}
                                            disabled={!HELPER.isUserHasUpdateAccess({ permissionID: ROLE_FEATURES['insurance_policy_shared'], accessType: 'edit', leadDetails: insuranceState.leadDetail, pageSlug: "policy_shared", selectedTab })}
                                        />
                                         <label data-label="Commission Rate %" className="form-label"></label>
                                        {
                                            errField[`commission_rate`]
                                                ?
                                                <span className="error-txt">{errField[`commission_rate`]}</span>
                                                :
                                                ''
                                        }
                                    </div>
                                </fieldset>
                            </div>

                        </div>
                    }
                   

                    <div>

                        <div className="btn-save-remarks m-xl-t">
                            {
                                HELPER.isUserHasUpdateAccess({ permissionID: (props.templateType === "broker" ? ROLE_FEATURES['send_to_insurance_broker'] : ROLE_FEATURES['insurance_policy_shared']), accessType: 'edit', leadDetails: insuranceState.leadDetail, pageSlug: (props.templateType === "broker" ? "sent_to_insurance_broker" : "policy_shared"), selectedTab }) && !props.disableSaveAndNext

                                    ?
                                    <button type="button" className="btn-primary" onClick={submitHandler}>{translations.commonMsg?.['Save & Next'] || translations.commonMsg?.loading}</button>
                                    :
                                    <button type="button" className="btn-primary" disabled>{translations.commonMsg?.['Save & Next'] || translations.commonMsg?.loading}</button>

                            }
                            {
                                props.showSendBackButton &&
                                <button type="button" className="btn-primary" onClick={props.onSendBackToAgent}>{translations.commonMsg?.['Send Back to Agent'] || 'Send Back to Agent'}</button>
                            }
                            {insuranceState?.leadDetail?.leadId && <LeadRemarksButton leadId={insuranceState.leadDetail.hashId} policyShareModal={policyShareModal} disabled={props.disableSaveAndNext} remark_source={props.templateType === "broker" ? "sent_to_insurance_broker" : "policy_shared"} />}

                        </div>
                    </div>
                </div>

                {
                    COUNTRY_CODE !== 'id' && (
                        <div className="view-timeline-popup image-timeline-popup fe-comment-popup">
                            <Modal show={showPaymentConfirmation} handleClose={() => { setShowPaymentConfirmation(false); setPaymentConfirmationData({ is_paid: "", paid_by: "" }) }} >
                                <div className="modal-header">
                                    <h2>Insurance Premium Amount</h2>
                                </div>
                                <div className="modal-body" >

                                    <ReactSelect
                                        options={CONFIRMATION_POPUP_VALUE}
                                        handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)}
                                        placeholder={(+insuranceState?.leadDetail?.application_type_id === +APP_TYPE_AGENCY) ? "Paid From Agency?" : "Paid By Customer?"}
                                        fieldKey="is_paid"
                                        fieldSetClassName={"col-md-6"}
                                        value={CONFIRMATION_POPUP_VALUE.find((el: any) => el.value === paymentConfirmationData?.is_paid) || null}
                                        errorField={errField.is_paid}
                                    />


                                    <ReactSelect
                                        options={showPaymentProofOptions}
                                        handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)}
                                        placeholder={"To"}
                                        fieldKey="paid_by"
                                        fieldSetClassName={"col-md-6"}
                                        value={showPaymentProofOptions.find((elm: any) => elm.value === paymentConfirmationData?.paid_by) || null}
                                        errorField={errField.paid_by}
                                    />


                                    <button className="btn-primary m-xl-t" onClick={paymentConfirnationHandler}>Submit</button>
                                </div>
                            </Modal>
                        </div>
                    )
                }


            </div >
        </div>

    );
};


export default ShareDetailsForm;
